import { DocumentDownloadService } from 'gw-portals-document-js';
import { getProxiedServiceUrl } from 'gw-portals-url-js';

export default class ClaimDocumentService {
    static getClaimDocument(documentID, token) {
        return DocumentDownloadService.getDocumentLink(getProxiedServiceUrl('claimDownloadDocument'), documentID, token);
    }
}
